import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./PasswordInput.css";
import Footer from "./Footer";

const PasswordInputPage = () => {
  const { t } = useTranslation("passwordinput");
  const navigate = useNavigate();
  const location = useLocation();
  const { lockerNo } = useParams();
  const { mainCode } = location.state || {};
  const [password, setPassword] = useState("");
  const locationMainCode = location.state?.mainCode || sessionStorage.getItem("mainCode");
  const passwordRef = useRef(null);

	useEffect(() => {
	  if (passwordRef.current) {
		passwordRef.current.focus();
	  }
	}, []);

  const KIOSK_NM = sessionStorage.getItem("KIOSK_NM");

  const getMainCodeLabel = (mainCode) => {
    switch (mainCode) {
      case "R": return t("type_reserve");
      case "F": return t("type_find");
      case "O": return t("type_open");
      default: return t("type_unknown");
    }
  };

const handleSubmit = async () => {
  if (password.length !== 4) {
    alert(t("password_4_digits"));
    return;
  }

  const unitcode = sessionStorage.getItem("UNITCODE");

  try {

    const statusRes = await fetch(`/api/kioskDetail/${unitcode}`);
    if (!statusRes.ok) throw new Error("KIOSK 상태 조회 실패");

    const kioskData = await statusRes.json();
    if (kioskData.KIOSK_LOGIN_ST === "N") {
      alert(t("kiosk_offline_message"));
      return;
    }

    const res = await fetch("/api/pwcheck", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        unitcode,
        lockerNo,
        user_pwd: password
      })
    });

    const result = await res.json();

    if (result.success) {
      if (locationMainCode === "O") {
        navigate("/LockerProcessing", {
          state: {
            mainCode: "O",
            lockerNo,
            password,
            type: "즉시개방"
          },
        });
      } else {
        navigate("/Payment", {
          state: {
            mainCode: locationMainCode,
            lockerNo,
            password
          },
        });
      }
    } else {
      alert(result.message || t("password_incorrect"));
    }
  } catch (err) {
    console.error("서버 오류:", err);
    alert(t("server_error"));
  }
};

  return (
    <div className="wrap">
      <header>
        <div className="title" onClick={() => navigate("/")}>
          <h1 dangerouslySetInnerHTML={{ __html: t("enter_password") }} />
        </div>
        <button className="back-button" onClick={() => window.history.back()}>
          ←
        </button>
      </header>

      <div className="reservation-info" style={{ borderBottom: 0 }}>
        <div className="reservation-info-box">
          <h2>{t("reservation_info")}</h2>
          <div className="dashed-line" />
          <div className="info-columns">
            <div className="column">
              <div className="label">{t("location")}</div>
              <div className="value">{KIOSK_NM}</div>
            </div>
            <div className="column">
              <div className="label">{t("locker_number")}</div>
              <div className="value">{lockerNo}</div>
            </div>
            <div className="column">
              <div className="label">{t("usage_type")}</div>
              <div className="value">{getMainCodeLabel(mainCode)}</div>
            </div>
          </div>
        </div>
      </div>

      <main className="content">
        <div className="form-wrapper">
          <div className="input-section">
            <label>{t("password")}</label>
				<input
				  type="password"
				  placeholder={t("password_placeholder")}
				  maxLength={4}
				  value={password}
				  onChange={(e) => setPassword(e.target.value.replace(/[^0-9]/g, ''))}
				  ref={passwordRef}
				/>
          </div>
          <button className="submit-button" onClick={handleSubmit}>
            다음
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PasswordInputPage;
